import { useEffect, useState } from 'react';
import { Box, Stack, Typography } from '@material-ui/core';
import Logo from '../Logo';

export default function SplashScreen() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Optional: simulate loading timeout
    const timer = setTimeout(() => {
      setLoading(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  if (!loading) return null; // Hide after loading if needed

  return (
    <Stack spacing={2} alignItems="center"
      sx={{
        height: '100vh',
        width: '100%',
        bgcolor: 'common.white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        textAlign: 'center',
        position: 'relative',
      }}
    >
      <Logo sx={{ width: 84, height: 84, }} />
      <Stack spacing={0.5} alignItems="center">
        <Typography variant="h4" sx={{ fontWeight: 600 }}>
          Hi Welcome To
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Mayura Logistics
        </Typography>
      </Stack>

      <Box sx={{ position: 'absolute', bottom: 25, left: 0, right: 0 }}>
        <Stack className='svg-spinners--12-dots-scale-rotate' sx={{ color: 'primary.main' }} />
      </Box>
    </Stack>
  );
}